// import './fonts/openSans/index.scss';
import './index.scss';
import 'reflect-metadata'; // DO NOT REMOVE THIS IMPORT
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { boot_di } from './services/ioc';
import { RootStore } from './store/root.store';
import { unregister } from './registerServiceWorker';
import './i18n';
import { environment, TAG_MANAGER_CONFIG } from './environment/environment';
import { tagManagerInit } from '@enterprise/shared';
import { StoresContext } from './contexts';
import { registerStores } from './pages/stores';
import ioc from './services/ioc';
import { Auth0Provider } from '@auth0/auth0-react';
import { getAuth0RedirectUri } from './router';
import { StyledEngineProvider } from '@mui/material/styles';

boot_di();
setTimeout(() => {
    const { AUTH0 } = environment;
    const redirectUrl = getAuth0RedirectUri();

    registerStores();
    tagManagerInit(TAG_MANAGER_CONFIG);
    const rootStore = ioc.get(RootStore);

    const container = document.getElementById('root');
    if (!container) {
        throw new Error('Root element #root not found');
    }

    const root = createRoot(container);
    root.render(
        <StoresContext.Provider value={rootStore}>
            <Auth0Provider
                domain={AUTH0.domain}
                clientId={AUTH0.clientId}
                authorizationParams={{
                    scope: AUTH0.scope,
                    audience: AUTH0.audience,
                    redirect_uri: redirectUrl,
                }}
                useRefreshTokens={true}
                cacheLocation={AUTH0.cacheLocation}
                cache={AUTH0.cache}
            >
                <StyledEngineProvider injectFirst>
                    <App />
                </StyledEngineProvider>
            </Auth0Provider>
        </StoresContext.Provider>,
    );

    unregister();
});
